import { ParticipantPickType } from '../../../../../common/betslip/core/picks/pick-models';
import { MyBetsRaceBetType } from '../../my-bets-base/models/my-bets-response';

export function getPickType(type: MyBetsRaceBetType): ParticipantPickType {
    switch (type) {
        case MyBetsRaceBetType.Win:
        case MyBetsRaceBetType.EachWay:
        case MyBetsRaceBetType.Place:
            return ParticipantPickType.Win;
        case MyBetsRaceBetType.Tricast:
            return ParticipantPickType.Tricast;
        case MyBetsRaceBetType.Forecast:
            return ParticipantPickType.Forecast;
        case MyBetsRaceBetType.CombinationTricast:
            return ParticipantPickType.CombinationTricast;
        case MyBetsRaceBetType.CombinationForecast:
            return ParticipantPickType.CombinationForecast;
    }
}
